import React, { memo } from 'react';
import PropTypes from 'prop-types';

import bn from '../../generalUtils/benames';

const bem = bn.create('toggleSwitch');
const CustomToggleSwitch = ({
  id,
  isChecked,
  onChange,
  name = undefined,
  label = undefined,
  className = '',
  labelClassName = undefined,
  isDisabled = false,
  title = '',
  size = 'sm',
  color = 'primary',
  type = 'round',
  labelPosition = 'right',
  hasIcon = null // { checked: 'fa-check', unchecked: 'fa-trash' }
}) => {
  const chkId = id ? id.toString().trim() : null;
  const isAddDisableClass = isDisabled ? 'disabledToggle' : '';
  const colorClass = color ? (isChecked ? `btn-${color} b-dark-100` : `btn-dark-400 b-dark-100`) : '';

  const renderLabel = () => (
    <label
      title={isDisabled ? 'Disabled' : typeof label === 'string' ? label : title}
      htmlFor={chkId}
      data-checked={isChecked || false}
      className={`col w-75 m-0 ${labelClassName || ''} ${isAddDisableClass}`}
    >
      {label}
    </label>
  );

  return (
    <div className={bem.b(className)}>
      <div className={`d-flex align-items-center ${className}`}>
        {labelPosition === 'left' && label && renderLabel()}

        <label className={`toggle-switch ${size} ${type} ${isAddDisableClass}`}>
          <input
            id={chkId}
            name={name}
            type="checkbox"
            checked={isChecked || false}
            disabled={isDisabled}
            onChange={onChange}
          />

          <span
            title={isDisabled ? 'Disabled' : typeof label === 'string' ? label : title}
            className={`slider ${size} ${colorClass} ${type}`}
            data-checked={isChecked || false}
          >
            {hasIcon && type !== 'strip' && (
              <i
                className={`slider-circle ${size} fa fa-${size} ${
                  isChecked ? hasIcon?.checked : hasIcon?.unchecked
                }`}
                style={{ fontSize: '0.8em' }}
              />
            )}
            <span
              className={`slider-circle ${size} ${type} ${isChecked ? 'bg-white' : 'bg-secondary-400'}`}
            />
          </span>
        </label>

        {labelPosition === 'right' && label && renderLabel()}
      </div>
    </div>
  );
};

CustomToggleSwitch.propTypes = {
  id: PropTypes.string,
  // isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  isDisabled: PropTypes.bool,
  title: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  type: PropTypes.oneOf(['round', 'strip', 'square']),
  labelPosition: PropTypes.oneOf(['left', 'right'])
};

CustomToggleSwitch.displayName = 'CustomToggleSwitch';
export default memo(CustomToggleSwitch);
